<template>
  <a-card title="工单类型配置">
    <a-table :columns="columns" :data-source="ticketTags" :loading="loading" children-column-name="“childrens”">
      <span slot="children" slot-scope="text, record">
        <a-tag v-for="item in record.children" :key="item.key" color="blue">{{ item.title }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="modalShow(record.key)">添加</a>
      </span>
    </a-table>
    <a-modal :visible="modalVisible" :closable="false" title="工单类型" @cancel="closeModal" @ok="onSubmit">
      <a-input v-model="tagName" allow-clear placeholder="请输入工单类型" />
    </a-modal>
  </a-card>
</template>

<script>
import { userList } from '@/api/system/auth';
import { ticketTags, updateTicketTag } from '@/api/event/problem';
export default {
  data() {
    return {
      ticketTags: null,
      loading: false,
      fatherId: 0,
      tagName: '',
      modalVisible: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'key',
          key: 'key',
          width: 70,
          scopedSlots: { customRender: 'key' }
        },
        {
          title: '父级名称',
          dataIndex: 'title',
          key: 'title',
          width: 140,
          scopedSlots: { customRender: 'title' }
        },
        {
          title: '工单类型',
          dataIndex: 'children',
          key: 'children',
          scopedSlots: { customRender: 'children' }
        },
        {
          title: '操作',
          key: 'action',
          width: 70,
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  mounted() {
    this.getConfigList();
  },
  methods: {
    modalShow(id) {
      this.modalVisible = true;
      this.fatherId = id;
    },
    closeModal() {
      this.modalVisible = false;
    },
    onSubmit() {
      let index = 1;
      let target = 0;
      for (let i = 0; i < this.ticketTags.length; i++) {
        index = index + 1;
        index = index + this.ticketTags[i].children.length;
        if (this.ticketTags[i].key === this.fatherId) {
          target = i;
        }
      }
      this.ticketTags[target].children.push({
        key: index,
        title: this.tagName,
        value: index
      });
      const ticketTags = this.ticketTags;
      updateTicketTag(ticketTags)
        .then(res => {});
      this.modalVisible = false;
    },
    getConfigList() {
      this.loading = true;
      ticketTags()
        .then(res => {
          this.ticketTags = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>
